import {
    Button,
    Form,
    Input,
    InputNumber,
    Modal,
    notification,
    Popconfirm,
    Space,
    Table,
    Tooltip,
    Typography
} from "antd";
import React, {useContext, useEffect, useState} from "react";
import DB_VendorCode from "../../../../database/dictionary/vendor_code";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../../modal";
import {Context} from "../../../../App";
import {CopyOutlined, EditOutlined} from "@ant-design/icons";

const EditableCell = ({
                          editing,
                          dataIndex,
                          title,
                          inputType,
                          record,
                          index,
                          children,
                          ...restProps
                      }) => {
    const inputNode = inputType === 'number' ? <InputNumber/> : <Input/>;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

const VendorCode = (props) => {
    const {token, setToken} = useContext(Context);
    const {getVendorCode, createVendorCode, updateVendorCode} = DB_VendorCode(token);
    const {t} = useTranslation();
    const {errorConnect} = ModalWindow();
    const [data, setData] = useState()

    const [wait, setWait] = useState(true)
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingKey, setEditingKey] = useState('');

    const isEditing = (record) => record.id === editingKey;


    const [form1] = Form.useForm();
    const [formV] = Form.useForm();

    const columns = [
        {
            title: 'ID',
            key: 'id',
            dataIndex: 'id',
            editable: false,
        },
        {
            title: t('name'),
            key: 'name',
            dataIndex: 'name',
            editable: true,
        },
        {
            title: t('short_name'),
            key: 'name_short',
            dataIndex: 'name_short',
            editable: true,
        },
        {
            title: '',
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
            <Typography.Link
                onClick={() => save(record.id)}
                style={{
                    marginRight: 8,
                }}
            >
              {t('save')}
            </Typography.Link>
            <Popconfirm title={t('q_sure_cancel')} onConfirm={cancel}>
            <a>{t('cancel')}</a>
            </Popconfirm>
          </span>
                ) : (
                    <Space>
                        <Tooltip title={t('edit')}>
                            <Button type={'text'} icon={<EditOutlined/>} disabled={editingKey !== ''}
                                    onClick={() => edit(record)}>
                            </Button>
                        </Tooltip>

                        <Tooltip title={t('copy')}>
                            <Button type={'text'} icon={<CopyOutlined/>} onClick={() => copy_vendor(record)}>
                            </Button>
                        </Tooltip>
                    </Space>
                );
            },
        },
    ];

    const copy_vendor = (record) => {

        form1.setFieldsValue({
            name: record.name,
            name_short: record.name_short,
            ...record,
        });
        showModal()
    }


    const edit = (record) => {
        formV.setFieldsValue({
            name: '',
            name_short: '',
            ...record,
        });
        setEditingKey(record.id);
    };

    const cancel = () => {
        setEditingKey('');
    };

    const save = async (key) => {
        const row = await formV.validateFields();
        const newData = [...data];
        const index = newData.findIndex((item) => key === item.id);


        const formData = new FormData();
        formData.append('name', row.name)
        formData.append('name_short', row.name_short)
        formData.append('id', key)


        if (await updateVendorCode(formData)) {
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {...item, ...row});
                setData(newData);
                setEditingKey('');
            } else {
                newData.push(row);
                setData(newData);
                setEditingKey('');
            }
        } else {
            openNotificationFailed(t('updating'));
        }


    };
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                // inputType: col.dataIndex === 'age' ? 'number' : 'text',
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    useEffect(() => {
        getVendorCode(props.id)
            .then(res => {
                setData(res.data)
                setWait(false)
            })
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            });
    }, [])

    const showModal = () => {
        if (!isModalVisible) {
            setIsModalVisible(true);
        }
    };

    const handleOk = async () => {
        if (form1.getFieldValue('name').length > 0 && form1.getFieldValue('name_short').length > 0) {
            const data = new FormData()
            data.append('name', form1.getFieldValue('name'))
            data.append('name_short', form1.getFieldValue('name_short'))
            data.append('product_id', props.id)

            if (await createVendorCode(data)) {
                setIsModalVisible(false);
                setWait(true);
                getVendorCode(props.id)
                    .then(res => {
                        setData(res.data);
                        setWait(false);
                    })
                    .catch(e => {
                        if (e.response.status === 403) {
                            window.location.reload();
                        }
                        errorConnect();
                        setWait(false);
                    });
            } else {
                openNotificationFailed(t('creating'));
            }
        }
    };

    const openNotificationFailed = (action) => {
        notification.error({
            message: t('failed'),
            description:
                t('e_update_create', {action: action, type: t('vendor_code').toLowerCase()}),
            placement: 'top'
        });
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <Space direction="vertical" style={{width: '80vh'}}>
            <Button type={'primary'} onClick={showModal}>{t('add_new_vendor_code')}</Button>
            <Form form={formV} component={false}>
                <Table
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    bordered
                    size={'small'}
                    dataSource={data}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    pagination={{
                        onChange: cancel,
                    }}
                    rowKey={'id'}
                    loading={wait}/>
            </Form>

            <Modal title={t('new_vendor_code')} visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                <Form
                    form={form1}
                    autoComplete="off">

                    <Form.Item
                        name="name"
                        label={t('name')}
                        rules={[
                            {
                                required: true,
                                message: t('e_input', {input: t('name').toLowerCase()}),
                            },
                        ]}
                        hasFeedback
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        name="name_short"
                        label={t('short_name')}
                        rules={[
                            {
                                required: true,
                                message: t('e_input', {input: t('short_name').toLowerCase()}),
                            },
                        ]}
                        hasFeedback
                    >
                        <Input showCount maxLength={50}/>
                    </Form.Item>
                </Form>
            </Modal>
        </Space>
    )
}

export default VendorCode;